import m from "../../geodata/es2015/maldivesHigh";
window.am4geodata_maldivesHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/maldivesHigh.js
// module id = null
// module chunks = 